<template>
  <NuxtLayout>
    <NuxtLoadingIndicator/>
    <!-- here -->
    <v-app style="padding: 1rem">
      <NuxtPage/>
    </v-app>
    <Toast />
  </NuxtLayout>
</template>
<script setup lang="ts">
import Toast from '@/components/common/Toast.vue'
import { onMounted } from 'vue'

const getImagePath = (imageName: any) => {
  const publicPath = import.meta.env.BASE_URL || '/nuxt/';
  return `${publicPath}${imageName}`;
}
useHead({
  title: ' MYDIT',
  link: [{rel: 'icon', type: 'image/png', href: getImagePath('images/brand-logos/favicon.ico')}]
})

// Le filtrage des erreurs Cloudflare est maintenant géré par le plugin cloudflare-error-filter.client.ts
// qui s'exécute avant ce composant pour intercepter les erreurs dès le chargement

</script>
<style>
.me-5 {
  margin-inline-end: 3rem !important;
}
</style>

